import { httpServices } from '../../system/HttpServices/HttpService';
export default {
    checkProspectEmail: function (data) {
        return httpServices.post({
            path: '/auth/checkEmail',
            data: data,
            withCredentials: true,
            requestType: 'community',
        });
    },
};
